import * as React from 'react'
import * as Loadable from 'react-loadable'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'

import { renderCenteredLoading } from '../ui/Spinner/helpers'

export const makeGoToUrl = dispatch => newUrl =>
  setTimeout(() => {
    dispatch(push(newUrl))
  }, 0)

export const getId = params => {
  return parseInt((params as any).id, 10)
}

export const Loading = props => {
  if (props.error) {
    return (
      <div style={{ padding: 25 }}>
        <h3>Nie mogłem pobrać części aplikacji</h3>
        <button onClick={props.retry}>Spróbuj ponownie</button>{' '}
        <a href="/">Wróć na stronę główną</a>
      </div>
    )
  } else if (props.pastDelay) {
    return renderCenteredLoading()
  } else {
    return null
  }
}

export function AsyncLoadable(opts) {
  return Loadable(
    Object.assign(
      {
        loading: Loading,
        delay: 200,
        timeout: 10,
      },
      opts,
    ),
  )
}

const mapStateToProps = (state, props) => ({})
const mapDispatchToProps = dispatch => ({
  goToUrl(url: string) {
    makeGoToUrl(dispatch)(url)
  },
})

export function withRouterHelpers<P extends RouteComponentProps<any>>(cmp) {
  return withRouter<P>(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(cmp),
  )
}
export type IdRouteProps = RouteComponentProps<{ id: string }>
